import { createContext } from 'react'

export interface CurrentPageMediaContext {
  arpMediaId?: number
  samplePackId?: number
}

export const CurrentPageContext = createContext<CurrentPageMediaContext>({
  arpMediaId: undefined,
  samplePackId: undefined
})
